module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "phoneIconBlack.94adf37a.svg";